//angular imports
import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { RoomTypeModel } from "@app/catalog";

//local imports
import { Transforms } from "@app/shared";

@Component({
  selector: "type-selection-list",
  templateUrl: "./type-selection-list.component.html",
  styleUrl: "./type-selection-list.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TypeSelectionListComponent {
  public types = input.required<RoomTypeModel[]>();
  public id = input.required<string>();
  public formGroup = input.required<FormGroup>();
  public label = input<string>("Room Type");
  public required = input(false, {
    transform: Transforms.toBoolean,
  });

  constructor() {}
}
